import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";
import { forms } from "../../../forms";

const update = async (data: FormData) => {
  const response: TServerResponse = await request({
    url: apiUrls.pagesContent.UPDATE_PAGES_CONTENT,
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const useUpdatePagesContentMutation = () => {
  return useMutation({ mutationFn: update });
};
